module.exports = __webpack_public_path__ + "static/media/cdb28.9b86fd4f.png";